module.exports = __webpack_public_path__ + "img/online-consultation-qrcode.a03b72e4.png";